import { createTheme } from '@mui/material'
import HAVDT from './HAVDesignTokens'
import { theme } from 'styles/theme/hav-theme'

const HAVTheme = createTheme({
  breakpoints: {
    values: {
      xs: 360,
      sm: 768,
      md: 1024,
      lg: 1440
    }
  },
  palette: {
    primary: {
      main: theme.colors.primary.main,
      contrastText: theme.colors.neutral.white
    },
    secondary: {
      main: theme.colors.secondary,
      contrastText: theme.colors.neutral.black
    },
    grey: {
      '50': theme.colors.neutral.mediumhover,
      '100': theme.colors.neutral.light,
      '900': theme.colors.neutral.medium
    },
    background: {
      default: theme.colors.quartenary
    },
    error: {
      main: theme.colors.support.error
    },
    warning: {
      main: theme.colors.support.warning
    },
    info: {
      main: theme.colors.quartenary
    },
    success: {
      main: theme.colors.support.success
    },
    text: {
      primary: theme.colors.neutral.medium,
      secondary: theme.colors.neutral.light,
      disabled: theme.colors.neutral.white
    }
  },
  typography: {
    fontFamily: theme.typography.family.primary,
    h1: {
      fontFamily: theme.typography.family.primary,
      fontWeight: theme.typography.weight.lg,
      fontSize: theme.typography.sizes['3xl'],
      lineHeight: 'normal'
    },
    h2: {
      fontFamily: theme.typography.family.primary,
      fontSize: theme.typography.sizes['2xl'],
      lineHeight: 'normal'
    },
    h3: {
      fontFamily: theme.typography.family.primary,
      fontWeight: theme.typography.weight.lg,
      fontSize: theme.typography.sizes.xl,
      lineHeight: 'normal'
    },
    h4: {
      fontFamily: theme.typography.family.primary,
      fontWeight: theme.typography.weight.md,
      fontSize: theme.typography.sizes.lg,
      lineHeight: 'normal'
    },
    h5: {
      fontFamily: theme.typography.family.primary,
      fontWeight: theme.typography.weight.lg,
      fontSize: theme.typography.sizes['2md'],
      lineHeight: 'normal'
    },
    subtitle1: {
      fontFamily: theme.typography.family.primary,
      fontWeight: theme.typography.weight.md,
      fontSize: theme.typography.sizes.md,
      lineHeight: 'normal'
    },
    body1: {
      fontFamily: theme.typography.family.primary,
      fontSize: theme.typography.sizes.sm,
      lineHeight: 'normal'
    },
    body2: {
      fontFamily: theme.typography.family.primary,
      fontWeight: theme.typography.weight.lg,
      fontSize: theme.typography.sizes.xs,
      lineHeight: 'normal'
    },
    button: {
      fontFamily: theme.typography.family.primary,
      fontWeight: theme.typography.weight.md,
      fontSize: theme.typography.sizes.xs
    }
  },
  HAVDesignTokens: {
    ...HAVDT
  },
  spacing: 5,
  shape: {
    borderRadius: 5
  },
  newTheme: {
    ...theme
  }
})

export default HAVTheme
